import { ToastContainer, toast } from "react-toastify";
import { CheckCircle, XCircle, Info } from "lucide-react";
import "react-toastify/dist/ReactToastify.css";

export const showSuccess = (msg) =>
  toast.success(msg, {
    icon: <CheckCircle size={18} color="#fff" />
  });

export const showError = (msg) =>
  toast.error(msg, {
    icon: <XCircle size={18} color="#fff" />
  });

export const showInfo = (msg) =>
  toast.info(msg, {
    icon: <Info size={18} color="#fff" />
  });

export const showReminder = () =>
  toast.info("Click on update to save the configuration.", {
    icon: <Info size={18} color="#fff" />
  });


export default function AppToast() {
  return (
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar
      closeOnClick
      pauseOnHover
      draggable={false}
      toastClassName="px-toast"
      bodyClassName="px-toast-body"
    />
  );
}
